import { z } from "@msuite/utils/lib/zod";
import { defineQuery } from "@rocicorp/zero";
import { zql } from "../zql";

/**
 * Vehicles on the board belong to the plan's organisation on every row today — the host supplies
 * them — so one arm is the whole rule, matching the plain policy the table carries.
 */
export const vehicleAssignmentQueries = {
	byCrewId: defineQuery(
		z.object({
			crewId: z.uuid(),
		}),
		({ args, ctx }) => {
			return zql.vehicleAssignments
				.where("crewId", "=", args.crewId)
				.where("orgId", "=", ctx.orgId)
				.related("vehicle", (vehicle) => vehicle.where("orgId", "=", ctx.orgId))
				.one();
		},
	),
};
